export default __webpack_public_path__ + "static/media/ida-mascot.ddd1a110.png";